import React from 'react';
import useStyle from './errorText.style';

export interface ErrorTextProps {
  text: string;
}

export const ErrorText = ({ text }: ErrorTextProps) => {
  const classes = useStyle();
  if (!text) return null;

  return <p className={classes.root}>{text}</p>;
};
